import { useHistory } from "react-router-dom";

import { useQueryString } from "app/context";

const useValueClick = value => {
  const { onToggleQueryStringValue } = useQueryString();
  const history = useHistory();

  return () => {
    if (onToggleQueryStringValue) {
      onToggleQueryStringValue("v", value.id);
    } else {
      history.push(`/recognitions?v=${value.id}`);
    }
  };
};

export default useValueClick;
